import React from 'react'
import Resources from '../../types/Resources';
import CompanyFormModal from './CompanyFormModal';
import useUpdateCompanyModal from './useUpdateCompanyModal';

export type UpdateCompanyModalProps = {
    companyId: string;
    resources: Resources;
    show: boolean;
    canManageIsEnergyHarbourCustomer: boolean;
    onCompanyUpdated: (updatedCompanyId: string) => void;
    onHide: () => void;   
}

function UpdateCompanyModal(props: UpdateCompanyModalProps) {
  const modalContent = useUpdateCompanyModal(props);
  
    return (
    <CompanyFormModal 
        show={props.show}
        canManageIsEnergyHarbourCustomer={props.canManageIsEnergyHarbourCustomer}
        formState={modalContent.formState}
        modalHeader={props.resources.get("UpdateCompany") ?? ""}
        onHide={props.onHide}
        onIsEnergyHarbourCustomerChange={modalContent.handleIsEnergyHarbourCustomerChange}
        onNameChange={modalContent.handleNameChange}
        onSubmit={modalContent.handleSubmitAsync}
        disableSubmit={modalContent.disableSubmit}
        isLoading={modalContent.isLoading}
        resources={props.resources}
    />
  )
}

export default UpdateCompanyModal